import { render, staticRenderFns } from "./DeliveryOrder.vue?vue&type=template&id=400de2fe&"
import script from "./DeliveryOrder.vue?vue&type=script&lang=ts&"
export * from "./DeliveryOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('400de2fe')) {
      api.createRecord('400de2fe', component.options)
    } else {
      api.reload('400de2fe', component.options)
    }
    module.hot.accept("./DeliveryOrder.vue?vue&type=template&id=400de2fe&", function () {
      api.rerender('400de2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/sales-transactions/DeliveryOrder.vue"
export default component.exports